import { IsBoolean } from 'class-validator';
import { BaseCreateDto } from '../base.dto';

/**
 * Only `isApproval` is declared. The review's remaining fields are relations with
 * no scalar id column (`trainingCondition`, `proposedDiagnosis`), so callers send
 * them as nested objects that pass through transformation unchanged — declaring
 * them would change the request contract, not tighten it.
 */
export class CreateTrainingConditionReviewDto extends BaseCreateDto {
  @IsBoolean()
  isApproval: boolean;
}
